import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { FormsModule } from '../../components/forms/forms.module';
import { NotesPageComponent } from './notes-page.component';
import { NotesService } from './service/notes.service';

/**
 * Created by Arturo Campos on 08/01/19.
 */
@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
    ],
    declarations: [NotesPageComponent],
    providers: [NotesService],
})
export class NotesPagesModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/notes/notes-pages.module.ts